export default object => ({
  id: object.id,
  status: object.status,
  name: object.name,
  email: object.email,
});
